module.exports = __webpack_public_path__ + "img/trend-before-1.f9e4ac15.png";